<template>
  <div class="modal">
    <div class="modal-container">
      <div>
        <div
          v-for="item in actionItems"
          :key="item.id"
          class="modal-button action-button"
          @click="$emit('click', item.action)"
        >{{item.action}}</div>
      </div>
      <div class="modal-button cancel-button">
        <div class="popup-button" v-if="cancelBtn" @click="$emit('cancelClick')">{{cancelBtn}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cms-popup",
  props: {
    cancelBtn: {
      default: null
    },
    actions: {
      default: null
    }
  },
  computed: {
    actionItems() {
      return this.actions.map((a, i) => {
        return {
          id: i,
          action: a
        };
      });
    }
  }
};
</script>

<style scoped lang="scss">
.modal {
  display: table-cell;
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: $modal-three-color;
}

.modal-container {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.5rem;
}

.modal-button {
  background-color: white;
  font-size: 1.2rem;
  padding: 0.36rem 0;
  color: $dark-sky-blue-color;

  &.action-button:first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }

  &.action-button:last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  &.action-button:not(:last-child) {
    border-bottom-color: $grey-five50-color;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  &.cancel-button {
    margin-top: 0.36rem;
    border-radius: 3px;
    font-weight: 700;
  }
}

.modal-close {
  padding-left: 90%;
}

.modal-body {
  text-align: left;
  padding: 0 0.7rem 0.7rem 0.7rem;
}

.button-container {
  border-top: 1px solid $white-one-color;
}

.popup-button:not(:first-child) {
  border-left: 1px solid $white-one-color;
}
</style>